import constate from 'constate'
import { useParams } from 'react-router'
import { useGetAppraisalResponseDetailsByIdQuery } from '@/features/appraisal/appraisal.api.ts'
import { isFetchBaseQueryHcError } from '@/utils/api.tsx'

export const [AppraisalResponseDetailsProvider, useAppraisalResponseDetails] = constate(() => {
  const { responseId } = useParams() as unknown as { responseId: number }
  const { data, refetch, isFetching, error } = useGetAppraisalResponseDetailsByIdQuery(responseId, {
    skip: !responseId,
  })

  if (error) {
    throw new Error(isFetchBaseQueryHcError(error) ? error.data.message : undefined)
  }

  return {
    data,
    refetch,
    isFetching,
  }
})